import { IWebchatVisitorsRepository } from 'modules/webchat/domain/repositories';
import { makeHTTPProvider } from 'shared/infra/providers';

import VectisWebchatVisitorsRepository from './implementations/VectisWebchatVisitorsRepository';

let instance: IWebchatVisitorsRepository | null = null;

export default function makeWebchatVisitorsRepository() {
  if (!instance) {
    instance = new VectisWebchatVisitorsRepository(makeHTTPProvider());
  }

  return instance;
}
